import CookieConsentBar from './CookieConsentBar.jsx';
export default CookieConsentBar;



// WEBPACK FOOTER //
// ./src/components/CookieConsentBar/index.js